import React, { Component } from 'react'
import PropTypes from 'prop-types' 
import TextWithLabel from '../../../components/common/TextWithLabel'
import Table from '../../../components/common/tables/Table'
import { translate, openNewWindowSameHost } from '../../../common/util'

class DefectsTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showDefectTable: false,
        }

        this.columns = [
            {
                header: 'จุดที่',
                accessor: 'id',
            },
            {
                header: 'รายละเอียดจุดบกพร่อง',
                accessor: 'title',
            },
            {
                header: 'ชนิดงาน',
                accessor: 'defectType',
                filterable: true
            },
            {
                header: 'ตำแหน่ง',
                accessor: 'location',
            },
        ]
    }

    render() {
        const { defects, status, rowClickCallback, inspectionId, productId } = this.props
        if (!defects) {
            return null
        }

        return (
            <div>
                <div className="d-flex flex-row py-1 justify-content-between align-items-center">
                    <div className="d-flex flex-column flex-md-row justify-content-start" style={{ width: "40%" }}>
                        <Status status={ status } />
                        <TextWithLabel label="จุดแก้ไขเพื่มเติม">
                            { defects.length }
                        </TextWithLabel>
                    </div>
                    <div className="d-flex flex-row flex-end">
                        <button 
                            onClick={() => openNewWindowSameHost(`/pqc-summary/${productId}/${inspectionId}`, null)} 
                            className="btn btn-outline mr-05" 
                            style={{ width: "fit-content", fontSize: "13px" }}
                            disabled={ defects.length === 0 ? true : false }
                        >
                            <i className="fa fa-download" /> สรุปรายการแก้ไข
                        </button>
                        <button 
                            className="btn btn-main" style={{ width: "8rem", fontSize: "13px" }}
                            onClick={ () => this.setState({ 
                                showDefectTable: !this.state.showDefectTable 
                            })} 
                        >
                            { this.state.showDefectTable
                                ? "ซ่อนรายการแก้ไข"
                                : "ดูรายการแก้ไข"
                            }
                        </button>
                    </div>
                </div>
                { this.state.showDefectTable
                    ? <Table 
                        columns={ this.columns } 
                        values={ defects }
                        rowClickCallback={ rowClickCallback } 
                    />
                    : null 
                }
            </div>
        )
    }
}

DefectsTable.propTypes = {
    defects: PropTypes.array.isRequired,
    rowClickCallback: PropTypes.func,
    status: PropTypes.string,
    inspectionId: PropTypes.string,
    productId: PropTypes.string,
}

export default DefectsTable

const Status = ({ status }) => {
    const text = translate('inspection_statuses', status)
    const color = status === '3' ? 'green'
        : status === '4' ? 'red'
        : 'black'

    return <div className="mr-3">
        <TextWithLabel label="สถานะ" color={ color }>{ text }</TextWithLabel>
    </div>
}
